function addDays(date, days) {
  return new Date(date.getFullYear(), date.getMonth(), date.getDate() + days);
}

/**
 * The preset ranges a range field offers, each relative to `today`. Weeks run Monday to Sunday.
 *
 * @param {Date} today
 * @returns {{ key: String, start: Date, end: Date }[]}
 */
export function rangeShortcuts(today) {
  const day = new Date(today.getFullYear(), today.getMonth(), today.getDate());
  const weekAgo = addDays(day, -7);
  const lastMonday = addDays(weekAgo, -((weekAgo.getDay() + 6) % 7));

  return [
    { key: "today", start: day, end: day },
    { key: "yesterday", start: addDays(day, -1), end: addDays(day, -1) },
    { key: "last_7_days", start: addDays(day, -6), end: day },
    { key: "last_week", start: lastMonday, end: addDays(lastMonday, 6) },
    { key: "month_to_date", start: new Date(day.getFullYear(), day.getMonth(), 1), end: day },
    {
      key: "previous_month",
      start: new Date(day.getFullYear(), day.getMonth() - 1, 1),
      end: new Date(day.getFullYear(), day.getMonth(), 0),
    },
    { key: "year_to_date", start: new Date(day.getFullYear(), 0, 1), end: day },
  ];
}
